/* eslint-disable */
import { Box, Divider, Group, Title } from "@mantine/core";
import React from "react";
import AttendanceTable from "./components/attendanceTable";

export default function Attendance() {
  return (
    <Box>
      <AttendanceTable />
    </Box>
  );
}
